"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFY_API_ERROR = 'NOTIFY_API_ERROR';
exports.NOTIFY_ERROR = 'NOTIFY_ERROR';
exports.CLEAR_ERROR = 'CLEAR_ERROR';
exports.SET_CONFIGURATION = 'SET_CONFIGURATION';
//# sourceMappingURL=types.js.map